import { Link, Wrapper, ConnectionView, Icon, Inserter, Image, SessionRole } from "nystem-components";
import { useState, useEffect } from "react";

const PartMenu = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const close = () => {
      if (open === true) setOpen(false);
    };
    setTimeout(() => {
      window.addEventListener("click", close);
    }, 0);
    return () => {
      window.removeEventListener("click", close);
    };
  }, [open]);

  return (
    <Wrapper
      renderAs="header"
      className="app-header -mb-10 w-full border-b border-emerald-950/10 bg-stone-50/95 py-1 pl-3 pr-2 shadow-sm backdrop-blur md:mx-0 print:hidden"
    >
      <Wrapper renderAs="nav" className="flex container m-auto justify-center items-center">
        <Link to="/" exact="true">
          <ConnectionView>
            <Image className="w-14 min-w-14 md:min-w-20" src="/image/Arbor_syd_trad.png" width="100" alt="logo" />
          </ConnectionView>
          <ConnectionView offline="true">
            <Image
              src="/image/Arbor_syd_trad.png"
              width="100"
              className="w-14 grayscale min-w-14 md:min-w-20"
              alt="logo"
            />
          </ConnectionView>
        </Link>
        <Wrapper className="grow" />
        <Inserter
          match="*"
          className="mr-6 flex overflow-hidden text-nowrap text-sm font-semibold text-emerald-950"
          source="/menu/view/main"
        />
        <Icon
          icon="bars"
          className="mx-1 h-10 min-w-10 cursor-pointer rounded-lg bg-emerald-900 p-2 text-white shadow md:hidden"
          onClick={() => setOpen(!open)}
        />
        <Wrapper className="relative w-1">
          {open ? (
            <Wrapper className="absolute right-0 mt-6 w-64 rounded-lg border border-stone-200 bg-white/95 p-2 text-base shadow-xl">
              <Inserter match="*" className="font-bold " source="/menu/view/main" />
              <SessionRole userrole="logged-in">
                <Link
                  to="/admin"
                  className="mt-2 flex items-center gap-2 border-t border-stone-200 px-3 py-2 font-semibold text-emerald-950"
                >
                  <Icon icon="gear" className="h-5 w-5" />
                  <span>Admin</span>
                </Link>
              </SessionRole>
            </Wrapper>
          ) : null}
        </Wrapper>
      </Wrapper>
    </Wrapper>
  );
};
export default PartMenu;
